// extracted by mini-css-extract-plugin
module.exports = {"svg":"Svg_svg__3URyZ"};